import { Button } from '@acpaas-ui/react-components';
import { useSelector } from 'react-redux';
import { DOSSIERS_RESOURCE } from '../../resources/dossiers.resource';
import { fetchingSelector } from '../../selectors/fetch.selectors';
import ResourceTable from '../core/ResourceTable';

const DossiersTable = ({ onExportCsv, canExportCsv }) => {
  const isFetchingDossiers = useSelector((state) => fetchingSelector(state, { resource: DOSSIERS_RESOURCE }));

  return (
    <ResourceTable
      resource={DOSSIERS_RESOURCE}
      actions={
        canExportCsv
          ? [
              <Button
                className="u-margin-right"
                size="small"
                iconRight="ai-download-bottom"
                disabled={isFetchingDossiers || !canExportCsv}
                onClick={onExportCsv}
              >
                Exporteer .csv
              </Button>
            ]
          : []
      }
    />
  );
};

export default DossiersTable;
